import { render, staticRenderFns } from "./departmentView.vue?vue&type=template&id=1ebc94b9&scoped=true"
import script from "./departmentView.vue?vue&type=script&lang=js"
export * from "./departmentView.vue?vue&type=script&lang=js"
import style0 from "./departmentView.vue?vue&type=style&index=0&id=1ebc94b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ebc94b9",
  null
  
)

export default component.exports